var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.handleProcess()}}},[_vm._v("Charge Deliver On Cancel")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }